import { getQueryParamsWithCustomQueryObj } from "@/utils/getQueryParamsFromCustomQueryObject";

const providerTypeDropdownParams = getQueryParamsWithCustomQueryObj({
  type: "LookupTypes",
  field: "value",
  filterBy: "type",
  filterValue: "provider_types",
});

export const serviceProviderEndpoints = {
  getServiceProviderList: "/service-providers/list",
  getOwnerInformation: "/service-providers/owner-information",
  updateStepData: "/service-providers",
  // updateOwnerInformation: "/service-providers/owner-information", // TODO: Add when PUT endpoint is available
  getOnboardingForm: "/service-providers/onboarding/form",
  getProviderTypeDropdown: `/dropdown?${providerTypeDropdownParams}`,
  submitServiceProvider: "/service-providers/submit",
  getServiceProviderOverview: "/alignment/service-provider-overview",
  resendEmail: "/service-providers/resend-email",
  licensesAndCertificates: "/service-providers/documents",
  parseDocument: "/service-providers/documents/parsing-status",
  idDocument: (serviceProviderId: string) => `/service-providers/id-document/${serviceProviderId}`,
  /** GET reads whether a W-9 is on file (SERV-2949); POST registers one. Same path, as with `idDocument`. */
  w9Document: (serviceProviderId: string) => `/service-providers/w9-document/${serviceProviderId}`,
  markDoNotUse: (serviceProviderId: string) => `/service-providers/do-not-use/${serviceProviderId}`,
  removeDoNotUse: (serviceProviderId: string) =>
    `/service-providers/do-not-use/${serviceProviderId}/remove`,
  doNotUseHistory: (serviceProviderId: string) =>
    `/service-providers/do-not-use/${serviceProviderId}/history`,
  setPassword: (serviceProviderId: string) => `/service-providers/password/${serviceProviderId}`,
};

export const stepFormStepId = {
  "personal-info": "owner-information",
  "business-info": "business-information",
  trades: "trade",
  rates: "rates",
  "payment-info": "payments",
  coverage: "coverage",
  summary: "summary",
  "licenses-certificates": "licenses-certificates",
  compensation: "compensation",
  documents: "onboarding-documents",
} as const;

export type StepFormStepId = keyof typeof stepFormStepId;
export type StepFormApiEndpoint = (typeof stepFormStepId)[StepFormStepId];
